<template>

</template>

<script>
export default {
    name: "InboxCompose"
}
</script>

<style scoped>

</style>
